export default __webpack_public_path__ + "static/media/blog.f8c63946.svg";